export function GrowthCurvePayingUsersEchartOp ({ v, data }) {
  let option = {
    grid: {
      left: '5%',
      top: '15%',
      right: '5%',
      bottom: '0%',
      containLabel: true
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'cross',
        crossStyle: {
          color: '#999'
        }
      }
    },
    legend: {
      icon: 'bar',
      data: ['月度会员付费比例', '累计付费用户'],
      itemWidth: v.fontSizeRem(1),
      itemHeight: v.fontSizeRem(0.25),
      textStyle: {
        color: 'rgba(255, 255, 255, 0.8)'
      }
    },
    xAxis: {
      name: '月',
      type: 'category',
      boundaryGap: false,
      data: [...data.date],
      axisLabel: {
        color: 'rgba(255, 255, 255, 1)'
      },
      nameTextStyle: {
        color: 'rgba(255, 255, 255,1)',
        padding: [0, 0, 0, 10]
      }

    },
    yAxis: [
      {
        name: '%',
        type: 'value',
        splitNumber: 5,
        axisLabel: {
          color: 'rgba(255, 255, 255, 1)'
        },
        axisLine: {
          show: true
        },
        splitLine: {
          show: false
        },
        nameTextStyle: {
          color: 'rgba(255, 255, 255,1)'
        }
      },
      {
        name: '万',
        type: 'value',
        splitNumber: 5,
        axisLabel: {
          color: 'rgba(255, 255, 255, 1)',
          formatter: function (d, c, a) {
            return v.numberSplitWithComma(d / 10000)
          }
        },
        nameTextStyle: {
          color: 'rgba(255, 255, 255,1)'
        },
        axisLine: {
          show: true
        },
        splitLine: {
          show: false
        }
      }
    ],
    series: [
      {
        name: '月度会员付费比例',
        // data: [56909300, 57026350, 57121124, 57240112, 57314623, 57392884, 57463488, 57520853, 57589437, 57651476, 57705581, 57760694, 57811083, 57850091, 57892765, 57935139, 57977259, 58020950, 58069912, 58113427, 58147195, 58189723, 58222115, 58251098, 58282009, 58320928, 58353388, 58379674],
        // data: (new Array(28)).fill(null),
        data: [...data.data.vaildVipRate],
        type: 'line',

        areaStyle: {
          color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [{
              offset: 0.6, color: 'rgba(0, 245, 255, 1)' // 0% 处的颜色
            }, {
              offset: 1, color: 'rgba(54, 65, 238, 1)' // 100% 处的颜色
            }]
          }
        },
        symbol: 'none',
        yAxisIndex: 0
      },
      {
        name: '累计付费用户',
        data: [...data.data.totalVip],
        type: 'line',
        yAxisIndex: 1,
        lineStyle: {
          color: 'rgba(110, 239, 255, 1)'
        },
        itemStyle: {
          color: 'rgba(110, 239, 255, 1)'
        }
      }
    ]
  }
  // for (let index = 1; index < 29; index++) {
  //   let date = index < 10 ? '0' + index : index
  //   option.xAxis.data.push(`02-${date}`)
  // }
  // for (let index = 1; index < 13; index++) {
  //   let date = index < 10 ? '0' + index : index
  //   option.xAxis.data.push(`${date}`)
  // }
  return option
}

export function UserRetentionPaymentIndexEchartOp ({ v, data }) {
  let option = {
    tooltip: {
      trigger: 'axis'
    },
    grid: {
      left: '-20%',
      top: '15%',
      right: '10%',
      bottom: '0%',
      containLabel: true
    },
    legend: {
      icon: 'bar',
      data: ['用户留存指数', '用户付费指数'],
      itemWidth: v.fontSizeRem(1),
      itemHeight: v.fontSizeRem(0.25),
      textStyle: {
        color: 'rgba(255, 255, 255, 0.8)'
      }
    },
    calculable: true,
    xAxis: [
      {
        name: '月',
        type: 'category',
        // prettier-ignore
        data: [...data.date],
        // data: ['03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '01', '02'],
        axisLabel: {
          color: 'rgba(255, 255, 255, 1)'
        },
        nameTextStyle: {
          color: 'rgba(255, 255, 255, 1)'
        }
      }
    ],
    yAxis: [
      {
        show: false,
        type: 'value',
        splitLine: {
          show: false
        }
      }
    ],

    series: [
      {
        name: '用户留存指数',
        type: 'bar',
        data: [...data.data],
        color: {
          type: 'linear',
          x: 0,
          y: 1,
          x2: 1,
          y2: 0,
          colorStops: [{
            offset: 0, color: '#4271EF' // 0% 处的颜色
          }, {
            offset: 1, color: '#2725EE' // 100% 处的颜色
          }]
        },
        markPoint: {
          data: [
            { type: 'max', name: 'Max' },
            { type: 'min', name: 'Min' }
          ]
        },
        markLine: {
          data: [{ type: 'average', name: 'Avg' }]
        }
      },
      {
        name: '用户付费指数',
        type: 'bar',
        color: {
          type: 'linear',
          x: 0,
          y: 1,
          x2: 1,
          y2: 0,
          colorStops: [{
            offset: 0, color: '#3DFFEE' // 0% 处的颜色
          }, {
            offset: 1, color: '#009BFF' // 100% 处的颜色
          }]
        },
        data: new Array(28).fill(null),
        markPoint: {
          data: [
            // { name: 'Max', value: 182.2, xAxis: 7, yAxis: 183 },
            // { name: 'Min', value: 2.3, xAxis: 11, yAxis: 3 }
          ]
        },
        markLine: {
          data: [{ type: 'average', name: 'Avg' }]
        }
      }
    ]
  }
  // for (let index = 1; index < 29; index++) {
  //   let date = index < 10 ? '0' + index : index
  //   option.xAxis[0].data.push(`02-${date}`)
  // }
  // for (let index = 1; index < 13; index++) {
  //   let date = index < 10 ? '0' + index : index
  //   option.xAxis[0].data.push(`${date}`)
  // }
  return option
}

export function UserPaymentDistributionEchartOp ({ v, data }) {
  let option = {
    tooltip: {
      trigger: 'item'
    },
    color: [
      {
        type: 'linear',
        x: 0,
        y: 0,
        x2: 0,
        y2: 1,
        colorStops: [{
          offset: 0, color: 'rgba(53, 255, 255, 1)' // 0% 处的颜色
        }, {
          offset: 1, color: 'rgba(11, 32, 245, 1)' // 100% 处的颜色
        }]
      }
    ],
    polar: {
      radius: ['50%', '100%']
    },
    angleAxis: {
      max: data.max,
      startAngle: 90,
      axisLine: {
        show: false
      },
      minorSplitLine: {
        show: false
      },
      splitLine: {
        show: false
      },
      axisLabel: {
        show: false
      },
      axisTick: {
        show: false
      }
    },
    radiusAxis: {
      type: 'category',

      // data: [
      //   '连续包月(续费)',
      //   '单点',
      //   '普通包月',
      //   '连续包月(购买)',
      //   '包年'
      // ],
      data: [...data.name],
      minInterval: 15,
      splitNumber: 15,
      axisLabel: {
        color: 'rgba(255, 255, 255, 1)',
        show: true,
        interval: 0// 不隐藏label
      },
      axisTick: {
        show: false
      },
      axisLine: {
        show: false
      },
      // boundaryGap: ['20%', '25%'],
      zlevel: 10
    },
    series: {
      type: 'bar',
      roundCap: true,
      data: [
        ...data.data
      ],
      coordinateSystem: 'polar',
      label: {
        show: false,
        position: 'right',
        formatter: '{b}'
      },
      showBackground: true,
      backgroundStyle: {
        color: '#22272CFF'
      },
      // barWidth: v.fontSizeRem(0.3),
      barCategoryGap: '70%'
    }
  }
  return option
}

export function AverageDailyStartupTimeEchartOp ({ v, data }) {
  let option = {
    grid: {
      left: '-5%',
      top: '5%',
      right: '0%',
      bottom: '10%',
      containLabel: false
    },
    xAxis: [{
      type: 'category',
      data: [...data.date],
      axisLabel: {
        color: 'rgba(255, 255, 255, 0.8)'
        // fontSize: v.fontSizeRem(0.75)
      },
      nameTextStyle: {
        show: false
      },
      axisLine: {
        show: false
      },
      axisTick: {
        show: false
      }
    }],
    yAxis: [{
      type: 'value',
      show: false,
      axisLabel: {
        color: 'rgba(255, 255, 255, 0.8)'
        // fontSize: v.fontSizeRem(0.75)
      },
      axisLine: {
        show: false
      }
    }],
    series: [{
      type: 'bar',
      color: {
        type: 'linear',
        x: 0,
        y: 1,
        x2: 0,
        y2: 0,
        colorStops: [{
          offset: 0, color: '#412DD0FF' // 0% 处的颜色
        }, {
          offset: 1, color: '#2BD6F9FF' // 100% 处的颜色
        }]
      },
      data: [...(data?.data ?? [])],
      barWidth: v.fontSizeRem(1.25),
      label: {
        show: true,
        position: 'top'
      }
    }]
  }

  return option
}

export function TypicalCharacteristicsMatureUsersEchartOp ({ v }) {
  let option = {
    radar: {
      shape: 'circle',
      indicator: [
        { name: '付费能力', max: 2000 },
        { name: '观影粘性', max: 2000 },
        { name: '应用偏好', max: 2000 },
        { name: '广告容忍', max: 2000 },
        { name: '活动兴趣', max: 2000 },
        { name: '活跃频次', max: 2000 }
      ],
      radius: '62%',
      splitLine: {
        // show: false,
        lineStyle: {
          // 使用深浅的间隔色
          color: ['rgba(30, 165, 166, 1)', 'RGBA(0, 0, 0, 0)', 'RGBA(0, 0, 0, 0)', 'RGBA(0, 0, 0, 0)', 'RGBA(0, 0, 0, 0)']
        }
      },
      splitArea: {
        areaStyle: {
          color: 'RGBA(28, 24, 57, 1)'
        }
      },
      startAngle: 180
    },

    series: [
      {
        name: 'Budget vs spending',
        type: 'radar',
        symbolSize: 0,
        areaStyle: {
          color: {
            type: 'linear',
            x: 1,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [{
              offset: 0, color: 'rgba(0, 245, 255, 1)' // 0% 处的颜色
            }, {
              offset: 1, color: 'rgba(54, 65, 238, 1)' // 100% 处的颜色
            }]
          }
        },
        data: [
          {
            value: [1780, 1680, 1400, 1313, 1515, 1860],
            name: 'Allocated Budget'
          }
        ]
      }

    ]
  }

  return option
}

export function UserTagCloudEchartOp ({ v, data }) {
// mock数据
//   let mockData = [{ name: '微信', value: 3328 }, { name: '南方+', value: 1045 }, { name: '东莞时间网',
//     value: 834 }, { name: 'i东莞', value: 804 }, { name: '新浪微博', value: 532 }, { name: '今日头条', value: 493 }, {
//     name: '腾讯新闻', value: 479 }, { name: '东莞阳光网', value: 387 }, { name: '东莞日报', value: 289 }, { name: '一点资讯',
//     value: 287 }, { name: '东方头条网', value: 233 }, { name: '南方都市报', value: 228 }, { name: '新粤网', value: 207 },
//   { name: '南方plus', value: 206 }, { name: '网易新闻', value: 201 }, { name: '东方头条', value: 180 }, { name:
// '趣头条',
//   value: 178 }, { name: '羊城派', value: 151 }, { name: '东莞时报', value: 143 }, { name: '莞讯网',
//     value:
// 139 }, { name: '广州日报', value: 137 }, { name: '东莞阳光台', value: 132 }, { name: '搜狐新闻', value: 129 }, {
//     name: '今日头条.APP', value: 116 }, { name: '东莞阳光平台', value: 108 }, { name: '腾讯新闻.APP', value: 107 }, {
//     name: '南方网', value: 103 }, { name: 'UC头条', value: 98 }, { name: '凤凰新闻', value: 93 }, { name: '报告诉',
//     value: 77 }, { name: '网易新闻.APP', value: 74 }, { name: '中国小康网', value: 64 }, { name: '东莞万江', value: 63 },
//   { name: '信息时报', value: 59 }, { name: '中国文明网', value: 58 }, { name: '东莞网', value: 57 }, { name:
// '搜狐新闻（自媒体）',
//   value: 54 }, { name: '南方日报', value: 54 }, { name: '搜狐焦点', value: 53 }, { name: '阳光社区',
//     value: 52 }, { name: '南方plus.APP', value: 47 }, { name: '阳光望牛墩', value: 46 }, { name: '中国报道', value: 43
//   }, { name: '新浪新闻', value: 43 }, { name: '房掌柜', value: 39 }, { name: '广州日报网', value: 38 }, { name:
// 'ZAKER',
//   value: 38 }, { name: '一点资讯.APP', value: 35 }, { name: '聚焦东莞', value: 35 }, { name: '广州新闻网',
//     value: 35 }, { name: '新浪', value: 31 }, { name: '东莞服务热线12345', value: 31 }, { name: '人民网', value: 29 },
//   { name: '阳光热线问政平台', value: 26 }, { name: '党报头条', value: 26 }, { name: '羊城晚报地方版', value: 24 }, { name:
// '网易房产',
//   value: 23 }, { name: '中国网', value: 22 }, { name: '金羊网', value: 21 }, { name: '东莞长安', value: 21
//   }, { name: '百家号', value: 21 }, { name: '澎湃新闻', value: 20 }, { name: '读特', value: 19 }, { name:
// '东方头条.APP',
//   value: 17 }, { name: '阳光石排', value: 16 }, { name: '新浪乐居', value: 16 }, { name: '微信邦',
//     value:
// 16 }, { name: '搜狐新闻.APP', value: 16 }, { name: '人民日报', value: 16 }, { name: '百度新闻', value: 16 }, { name:
// '南方都市报.APP',
//   value: 15 }, { name: '荔枝网', value: 15 }, { name: '华人头条', value: 15 }, { name: '广东建设报',
//     value: 15 }, { name: '中国', value: 14 }, { name: '阳光黄江', value: 14 }, { name: '东方网', value: 14 }, { name:
// '网易',
//   value: 12 }, { name: '搜狐网', value: 12 }, { name: '和讯', value: 12 }, { name: '文化莞城', value: 11 }, {
//     name: '聊聊网', value: 11 }, { name: '58同镇', value: 11 }, { name: '凤凰网', value: 10 }, { name: '新浪网',
//     value:
// 9 }, { name: '趣头条.APP', value: 9 }, { name: '凤岗网', value: 9 }, { name: '新快网_新快报', value: 8 }, { name:
// '上游新闻',
//   value: 8 }, { name: '东莞市城市综合管理局', value: 8 }, { name: '大众网', value: 8 }, { name: '中国新闻网',
//     value:
// 7 }, { name: '第一推', value: 7 }, { name: '大洋网', value: 7 }, { name: '新浪网', value: 6 }, { name: '新浪看点',
//     value: 6 }, { name: '手机和讯网', value: 6 } ].slice()
  // let mockData = [{ name: '点播类型偏好', value: 88 }, { name: '用户属性', value: 80 }, { name: '点播题材偏好',
  //   value: 41 }, { name: '文化属性', value: 40 }, { name: '设备信息', value: 38 }, { name: '生活+VIP会员权益', value: 19 }, {
  //   name: '用户体系行为', value: 19 }, { name: '教育VIP会员权益', value: 16 }, { name: '主页行为', value: 15 }, { name: '教育少儿VIP会员权益',
  //   value: 15 }, { name: '年龄分布', value: 14 }, { name: '地理信息', value: 12 }, { name: '家庭属性', value: 11 }, { name: '购书行为', value: 11 },
  // { name: '信息行为', value: 10 }, { name: '内容VIP用户行为', value: 8 }, { name: '少儿行为', value: 7 }, { name: '周末收视时段', value: 6 },
  // { name: 'K歌行为', value: 5 }, { name: '收视时段', value: 2 }].slice()
  let mockData = [...data]
  // 随机颜色
  let randcolor = () => {
    let r = 0 + ~~(Math.random() * 176)
    let g = 104 + ~~(Math.random() * 106)
    let b = 230 + ~~(Math.random() * 25)
    return `rgb(${r}, ${g}, ${b})`
  }
  let option = {
    tooltip: {
      trigger: 'item',
      padding: [10, 15],
      textStyle: {
        fontSize: 20
      },
      formatter: params => {
        const { name, value } = params

        return `
                  标签：${name} <br/>
                  数量：${value}
              `
      }
    },
    series: [{
      type: 'wordCloud',
      gridSize: 5,
      sizeRange: [6, 40],
      rotationRange: [0, 0],
      shape: 'circle',
      textStyle: {
        color: params => {
          return randcolor()
        },
        emphasis: {
          shadowBlur: 10,
          shadowColor: '#333'
        }
      },
      data: mockData
    }]
  }
  return option
}
